import * as types from "../mutation-types";
import logger from "~/utilities/logger";

export const state = {
  events: [],
  weekendsVisible: true,
  holidaysVisible: true,
};

export const getters = {
  events: (state) => state.events,
  weekendsVisible: (state) => state.weekendsVisible,
  holidaysVisible: (state) => state.holidaysVisible,
};

//utils
export const getEventIndexById = (state, eventId) =>
  state.events.findIndex((event) => event.id.toString() === eventId.toString());

// mutations
export const mutations = {
  [types.CREATE_EVENT](state, event)
  {
    return state.events.push(event);
  },
  [types.UPDATE_EVENT](state, updatedEvent)
  {
    const index = getEventIndexById(state, updatedEvent.id);
    logger.log("store.UPDATE_EVENT", updatedEvent);
    if (index === -1)
    {
      return console.warn(`Unable to update event (id ${updatedEvent.id})`);
    }

    return state.events.splice(index, 1, {
      ...state.events[index],
      title: updatedEvent.title,
      start: updatedEvent.start,
      end: updatedEvent.end,
      date: updatedEvent.date,
      // FullCalendar 7 uses one `color` property for background and border.
      color: updatedEvent.color ?? updatedEvent.backgroundColor ?? state.events[index].color,
      extendedProps: {
        confirmed: updatedEvent.extendedProps.confirmed,
        groupId: updatedEvent.extendedProps.groupId,
        desc: updatedEvent.extendedProps.desc,
        topology: updatedEvent.extendedProps.topology,
        timeline: updatedEvent.extendedProps.timeline,
        createdBy: updatedEvent.extendedProps.createdBy,
        updatedBy: updatedEvent.extendedProps.updatedBy,
      },
    });
  },
  [types.DELETE_EVENT](state, eventId)
  {
    logger.log("store.DELETE_EVENT", state, eventId);
    const index = getEventIndexById(state, eventId);

    if (index === -1)
    {
      return console.warn(`Unable to delete event (id ${eventId})`);
    }

    return state.events.splice(index, 1);
  },
  [types.SET_WEEKENDS_ENABLED](state, enabled)
  {
    state.weekendsVisible = enabled;
  },
  [types.SET_HOLIDAYS_ENABLED](state, enabled)
  {
    state.holidaysVisible = enabled;
  },
  [types.CLEAR_EVENTS](state)
  {
    state.events = [];
  },
};

// actions
export const actions = {
  createEvent({ commit }, event)
  {
    return commit(types.CREATE_EVENT, event);
  },
  updateEvent({ commit }, updatedEvent)
  {
    return commit(types.UPDATE_EVENT, updatedEvent);
  },
  deleteEvent({ commit }, eventId)
  {
    return commit(types.DELETE_EVENT, eventId);
  },
  setweekendsVisible({ commit }, enabled)
  {
    return commit(types.SET_WEEKENDS_ENABLED, enabled);
  },
  setholidaysVisible({ commit }, enabled)
  {
    return commit(types.SET_HOLIDAYS_ENABLED, enabled);
  },
  clearEvents({ commit })
  {
    return commit(types.CLEAR_EVENTS);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
